import { storage } from "../firebase";
import { ref, deleteObject } from "firebase/storage";

/**
 * Deletes a file from Firebase Cloud Storage.
 * @param {string} path - The path of the file to delete.
 * @returns {Promise<void>}
 */
const deleteFileFromCloud = async (path) => {
  try {
    const fileRef = ref(storage, path);
    await deleteObject(fileRef);
    console.log(`File deleted from path: ${path}`);
  } catch (error) {
    console.error("Failed to delete file:", error);
    throw error;
  }
};

export default deleteFileFromCloud;
